import './src/main.css'
import Decoration6 from './src/main.vue'

export default function (Vue) {
  Vue.component(Decoration6.name, Decoration6)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/decoration6/index.js